var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M370.223,0H141.777c-17.015,0-30.857,13.841-30.857,30.848V51.2h290.15V30.848C401.071,13.841,387.23,0,370.223,0z     M298.671,42.667h-85.333c-4.71,0-8.533-3.823-8.533-8.533c0-4.71,3.823-8.533,8.533-8.533h85.333c4.71,0,8.533,3.823,8.533,8.533    C307.204,38.844,303.381,42.667,298.671,42.667z M358.404,42.667h-8.533c-4.71,0-8.533-3.823-8.533-8.533    c0-4.71,3.823-8.533,8.533-8.533h8.533c4.71,0,8.533,3.823,8.533,8.533C366.938,38.844,363.115,42.667,358.404,42.667z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#5F7D95"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M266.594,452.267h-21.188c-3.567,0-6.477,2.901-6.477,6.477v4.122c0,3.567,2.901,6.468,6.477,6.468h21.188    c3.567,0,6.468-2.901,6.468-6.468v-4.122C273.071,455.168,270.161,452.267,266.594,452.267z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#5F7D95"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110.938,
    y: 68.267,
    width: 290.133,
    height: 341.333,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#5F7D95"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.938,426.667v54.485c0,17.007,13.841,30.848,30.848,30.848h228.446c17.007,0,30.848-13.841,30.848-30.848v-54.485    H110.938z M290.138,462.865c0,12.979-10.556,23.535-23.535,23.535h-21.188c-12.979,0-23.543-10.556-23.543-23.535v-4.122    c0-12.979,10.564-23.543,23.543-23.543h21.188c12.979,0,23.535,10.564,23.535,23.543V462.865z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#5F7D95"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGray);
export default __webpack_public_path__ + "static/media/phone_gray.8eff588aa997c745326af84a5e5aa6f0.svg";
export { ForwardRef as ReactComponent };